import React, { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import api from "../lib/api";
import { CalendarDays, MapPin, Ticket, Euro } from "lucide-react";

export default function Eventi() {
  const { content } = useOutletContext() || {};
  const c = content || {};
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/events").then(r => setEvents(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
      <div className="mb-10">
        <div className="tag-pill mb-4">Eventi & Programmazione</div>
        <h1 className="font-display text-5xl sm:text-6xl uppercase text-white" data-testid="events-heading">{c.eventi_title || "Eventi del circolo"}</h1>
        <p className="mt-3 text-white/70 max-w-2xl whitespace-pre-line">{c.eventi_subtitle || ""}</p>
      </div>
      {loading && <div className="text-white/70" data-testid="events-loading">Caricamento...</div>}
      {!loading && events.length === 0 && (
        <div className="card p-10 text-center" data-testid="events-empty">
          <div className="font-display text-3xl uppercase">Nessun evento ancora</div>
          <p className="mt-2 text-white/70">Torna presto — stiamo scrivendo il calendario.</p>
        </div>
      )}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {events.map(e => (
          <Link key={e.id} to={`/eventi/${e.id}`} className="card overflow-hidden group" data-testid={`event-card-${e.id}`}>
            <div className="aspect-square bg-black overflow-hidden flex items-center justify-center">
              {e.poster_url ? (
                <img src={e.poster_url} alt={e.title} className="w-full h-full object-contain group-hover:scale-[1.02] transition-transform"/>
              ) : (
                <div className="text-white/40 font-display text-4xl">FLOW</div>
              )}
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 text-xs text-[#FFFFFF] font-mono uppercase tracking-widest">
                <CalendarDays size={12}/> {new Date(e.date).toLocaleString("it-IT", { day:"2-digit", month:"short", hour:"2-digit", minute:"2-digit"})}
              </div>
              <h3 className="mt-2 font-display text-2xl uppercase leading-tight">{e.title}</h3>
              <div className="mt-2 flex items-center gap-3 text-sm text-white/70">
                <span className="flex items-center gap-1"><MapPin size={12}/> {e.location}</span>
              </div>
              <div className="mt-4 flex items-center justify-between">
                {e.price_on_request ? (
                  <span className="tag-pill">Prezzo su richiesta</span>
                ) : e.free ? (
                  <span className="tag-pill">Ingresso gratuito</span>
                ) : (
                  <span className="tag-pill"><Euro size={12}/> {e.price.toFixed(2)}</span>
                )}
                <span className="text-xs font-mono uppercase text-white/50 group-hover:text-[#FFFFFF] flex items-center gap-1"><Ticket size={12}/> Dettagli</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
